import React from 'react';
import { Home, ClipboardList, CheckSquare, Calendar, Gift, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { BRAND_CONFIG } from '../config/brand';

interface SidebarProps {
  activeModule: string;
  setActiveModule: (module: string) => void;
  isOpen: boolean;
  userProfile: any;
}

const navItems = [
  { id: 'dashboard', icon: Home, label: '總覽' },
  { id: 'rsvp', icon: ClipboardList, label: '賓客管理' },
  { id: 'tables', icon: CheckSquare, label: '座位安排' },
  { id: 'gifts', icon: Gift, label: '紅包管理' },
  { id: 'timeline', icon: Calendar, label: '時間規劃' },
];

export const Sidebar: React.FC<SidebarProps> = ({ activeModule, setActiveModule, isOpen, userProfile }) => {
  const { signOut } = useAuth();

  return (
    <aside className={`bg-wedding-bg transition-all duration-300 ease-in-out ${isOpen ? 'w-64' : 'w-0'} overflow-hidden`}>
      <div className="flex flex-col h-full">
        <div className="h-16 py-4 px-6 border-b border-wedding-pink/30 flex items-center justify-between">
          <div className={`flex items-center transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`}>
            <img src={BRAND_CONFIG.logo} alt={BRAND_CONFIG.logoAlt} className="h-10 w-10 mr-3"/>
            <span className="text-xl font-bold text-wedding-text-title">{BRAND_CONFIG.name}</span>
          </div>
        </div>

        <nav className="flex-1 py-4 px-2 space-y-2">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveModule(item.id)}
              className={`w-full flex items-center py-3 px-4 rounded-lg transition-colors duration-200 ${
                activeModule === item.id
                  ? 'bg-wedding-pink/10 text-wedding-pink font-medium'
                  : 'text-wedding-text-body hover:bg-wedding-pink/10'
              }`}>
              <item.icon className="h-5 w-5 mr-4" />
              <span className={`transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`}>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="p-4 border-t border-wedding-pink/20">
          <div className={`transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`}>
            <div className="flex items-center mb-4">
              <div className="h-10 w-10 rounded-full bg-wedding-pink flex items-center justify-center text-white font-bold text-lg mr-3">
                {userProfile?.displayName?.charAt(0) || 'U'}
              </div>
              <div>
                <p className="font-semibold text-wedding-text-title">{userProfile?.displayName || 'User'}</p>
                <p className="text-xs text-wedding-text-body">{userProfile?.email || ''}</p>
              </div>
            </div>
            <button
              onClick={signOut}
              className="w-full flex items-center py-2 px-4 rounded-lg text-wedding-text-body hover:bg-wedding-pink/10 transition-colors duration-200">
              <LogOut className="h-5 w-5 mr-4" />
              <span className={`transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`}>登出</span>
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
};
